"use client";
import React from "react";
import { ACTIONS, CallBackProps, STATUS, Step } from "react-joyride";
import { TourContext } from "@quales/utils/context";
import dynamic from "next/dynamic";
import { Stack } from "@mui/material";
import { useRouter } from "next/router";

const JoyRideNoSSR = dynamic(() => import("../../ui/tour/TourComponent"), {
  ssr: false,
});

interface UserTourProps {
  onAddUserModalClicked?: () => void;
}

const TOUR_STEPS: Step[] = [
  {
    target: "#Layout",
    content: (
      <div>
        Hoi, we gaan je laten zien hoe je een nieuwe gebruiker toevoegd.
      </div>
    ),
    placement: "center",
  },
  {
    content: (
      <div>
        <br />
        <h3>Klik hier om naar het gebruikersoverzicht te gaan.</h3>
      </div>
    ),

    hideCloseButton: true,

    target: "#userMenuIcon",
    title: "User Menu Nav",
  },
  {
    content: (
      <div>
        <br />
        <h3>Klik hier om een nieuwe gebruiker aan te maken.</h3>
      </div>
    ),

    target: "#userCreate",
  },
  {
    content: (
      <div>
        <br />
        <h3>Vul hier de gegevens van de gebruiker in. </h3>
      </div>
    ),

    target: "#userModal",
  },
  {
    content: (
      <div>
        <br />
        <h3>
          Super! nieuwe gebruiker is toegevoegd. De gebruiker krijgt een e-mail
          om zijn/haar wachtwoord te zetten. Daarna kan Quales gebruikt worden.
        </h3>
      </div>
    ),

    target: "#userBody",
  },
];

export const UserTour = ({ onAddUserModalClicked }: UserTourProps) => {
  const { tour, handleUpdateTour } = React.useContext(TourContext);
  const [runTour, setRunTour] = React.useState(false);
  const router = useRouter();

  React.useEffect(() => {
    if (tour && tour.tourID === "2") {
      setRunTour(true);
    }
  }, [tour]);

  const handleTourCallBack = (data: CallBackProps) => {
    const { action, index, status, type } = data;

    if (action === "close") {
      setRunTour(false);
      handleUpdateTour({
        tourID: null,
        tourStep: 0,
      });
    }
    if (type === "tour:start" && index < tour.tourStep) {
      handleUpdateTour({
        tourID: "2",
        tourStep: tour.tourStep,
      });
    } else if (
      ([STATUS.FINISHED, STATUS.SKIPPED] as string[]).includes(status)
    ) {
      setRunTour(false);
      handleUpdateTour({
        tourID: null,
        tourStep: 0,
      });
    } else {
      const nextStepIndex = index + (action === ACTIONS.PREV ? -1 : 1);

      if (
        action === ACTIONS.NEXT &&
        type === "step:after" &&
        nextStepIndex < 2
      ) {
        handleUpdateTour({
          tourID: "2",
          tourStep: nextStepIndex,
        });
      } else {
        if (action === "next" && type === "step:after" && index === 1) {
          handleUpdateTour({
            tourID: "2",
            tourStep: 2,
          });
          router.push("/UserOverview");
        }
        if (action === "next" && type === "step:after" && nextStepIndex === 3) {
          handleUpdateTour({
            tourID: "2",
            tourStep: nextStepIndex,
          });

          onAddUserModalClicked();
        }
        if (action === "prev" && type === "step:after" && index === 2) {
          handleUpdateTour({
            tourID: "2",
            tourStep: 1,
          });
        }
        if (action === "prev" && type === "step:after" && index === 1) {
          handleUpdateTour({
            tourID: "2",
            tourStep: 0,
          });
          router.push("/");
        }

        if (action === "next" && type === "step:after" && index === 2) {
          handleUpdateTour({
            tourID: "2",
            tourStep: nextStepIndex,
          });
        }

        if (action === "next" && type === "step:after" && index === 3) {
          handleUpdateTour({
            tourID: "2",
            tourStep: nextStepIndex,
          });
        }

        if (action === "next" && type === "step:after" && index === 4) {
          setRunTour(false);
          handleUpdateTour({
            tourID: null,
            tourStep: 0,
          });
        }
      }
    }
  };

  return (
    <Stack>
      {runTour && (
        <JoyRideNoSSR
          joyRideCallback={handleTourCallBack}
          runState={runTour}
          stepIndex={tour.tourStep}
          steps={TOUR_STEPS}
        />
      )}
    </Stack>
  );
};

export default UserTour;
